<script>
  export default {
    components: { },
    props: {
      mensagem: {
        required: true
      },
      index: {
        required: true,
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
    },
    methods: {
      parImpar() {
        return (this.index % 2)
      },
    }
  }
</script>

<template>
  <div class="containerChat">
    <p :class="['nomepessoa', parImpar() == 0 ? 'nomepessoaPar' : 'nomepessoaImpar']">{{ mensagem.usuario }}</p>
    <p class="status" style="color: green" v-if="mensagem.qntNaoLida == 0">&#10004;</p>
    <p class="mensagem">{{ mensagem.mensagem }}</p>
    <p class="tempo">{{ mensagem.dataHoraStr }}</p>
  </div>
</template>

<style>
  .containerChat {
    background-color: white;
    width: auto;
    height: auto;
    position: relative;
    margin: 10px 10px 0px 10px;
    padding: 10px 10px 10px 10px;
    border-radius: 10px;
  }

  .nomepessoa {
    font-family: Tahoma;
    text-decoration: underline;
    font-size: 13px;
  }

  .tempo {
    font-family: Tahoma;
    font-size: 11px;
    color: gray;
    position: absolute;
    bottom: 10px;
    right: 20px;
  }

  .mensagem {
    font-family: Tahoma;
    color: #4A4A4A;
    padding-bottom: 20px;
    padding-top: 10px;
    font-size: 13px;
  }

  .status {
    position: absolute;
    top: 10px;
    right: 20px;
  }

  .nomepessoaPar {
    color: purple;
  }

  .nomepessoaImpar {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/chat/componentes/Mensagens.vue